import { RepoType } from 'api'
import { createSelector, Selector } from '@reduxjs/toolkit'
import { compact } from 'lodash'
import { AxeDetail } from 'selectors/axeSelectors'
import { createCollateralsFromInstrumentIdGetterSelector } from 'selectors/instrumentSelectors'
import {
  createOrganisationCanTradeCollateralBasketsSelector,
  createOrganisationCanTradeCollateralsSelector,
  createOrganisationHasTradingRelationshipWithFundsAsSideSelector,
  organisationHasRepoTypeSBL
} from 'selectors/organisationSelectors/organisationFilterSelectors'

export const createOrganisationFiltersForAxeCounterpartySelector = <TProps>(axeDetailSelector: Selector<{}, AxeDetail, [TProps]>) =>
  createSelector(
    [
      axeDetailSelector,
      createCollateralsFromInstrumentIdGetterSelector(),
      createOrganisationCanTradeCollateralBasketsSelector,
      createOrganisationCanTradeCollateralsSelector,
      createOrganisationHasTradingRelationshipWithFundsAsSideSelector
    ],
    (
      axeDetails,
      getCollateralsFromInstrumentId,
      createOrganisationCanTradeCollateralBaskets,
      createOrganisationCanTradeCollaterals,
      createOrganisationHasTradingRelationshipWithFundsAsSide
    ) => {
      const {
        instrument,
        initiatorTradingEntity,
        side,
        axe: { marketType, repoType }
      } = axeDetails

      const { collateral, collateralBasket } = instrument
        ? getCollateralsFromInstrumentId(instrument.id)
        : { collateral: null, collateralBasket: null }

      return compact([
        collateralBasket && createOrganisationCanTradeCollateralBaskets([{ collateralBasket, marketType }]),
        collateral && createOrganisationCanTradeCollaterals([{ collateral, marketType }]),
        initiatorTradingEntity && createOrganisationHasTradingRelationshipWithFundsAsSide([initiatorTradingEntity.id], side),
        repoType === RepoType.STOCK_BORROWING_LENDING && organisationHasRepoTypeSBL
      ])
    }
  )
